module.exports = __webpack_public_path__ + "static/img/2_v2.71af157e.png";